module.exports = __webpack_public_path__ + "static/media/E6.7ac6acab.png";